import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-kpi-cards',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
      <!-- Total Sessions -->
      <div class="bg-zaxis-dark border border-zaxis-border p-5 relative overflow-hidden group hover:border-zaxis-accent transition-colors rounded-none">
        <div class="flex items-center justify-between mb-4 relative z-10">
          <span class="text-[10px] text-gray-500 uppercase tracking-widest font-mono">Sesiones Totales</span>
          <i class="ph ph-chart-line-up text-lg text-zaxis-accent"></i>
        </div>
        <p class="text-4xl font-mono text-white relative z-10 tracking-tight">{{ sessionsCount }}</p>
        <div class="absolute bottom-0 left-0 h-1 bg-zaxis-accent w-0 group-hover:w-full transition-all duration-500"></div>
      </div>

      <!-- Crashes -->
      <div class="bg-zaxis-dark border border-zaxis-border p-5 relative overflow-hidden group hover:border-zaxis-danger transition-colors rounded-none">
        <div class="flex items-center justify-between mb-4 relative z-10">
          <span class="text-[10px] text-gray-500 uppercase tracking-widest font-mono">Crashes / Fallos</span>
          <i class="ph ph-warning-circle text-lg text-zaxis-danger"></i>
        </div>
        <div class="flex items-baseline gap-3 relative z-10">
          <p class="text-4xl font-mono text-white tracking-tight">{{ crashCount }}</p>
          <span *ngIf="sessionsCount > 0" class="text-[11px] font-mono text-zaxis-danger bg-zaxis-danger/10 px-2 py-1 border border-zaxis-danger/20">{{ crashRate }}%</span>
        </div>
        <div class="absolute bottom-0 left-0 h-1 bg-zaxis-danger w-0 group-hover:w-full transition-all duration-500"></div>
      </div>

      <!-- Avg FPS -->
      <div class="bg-zaxis-dark border border-zaxis-border p-5 relative overflow-hidden group hover:border-zaxis-success transition-colors rounded-none">
        <div class="flex items-center justify-between mb-4 relative z-10">
          <span class="text-[10px] text-gray-500 uppercase tracking-widest font-mono">FPS Promedio</span>
          <i class="ph ph-lightning text-lg text-zaxis-success"></i>
        </div>
        <p class="text-4xl font-mono text-white relative z-10 tracking-tight">{{ globalAvgFps | number:'1.0-0' }} <span class="text-[11px] text-gray-600 uppercase font-mono">fps</span></p>
        <div class="absolute bottom-0 left-0 h-1 bg-zaxis-success w-0 group-hover:w-full transition-all duration-500"></div>
      </div>

      <!-- Devices -->
      <div class="bg-zaxis-dark border border-zaxis-border p-5 relative overflow-hidden group hover:border-purple-500 transition-colors rounded-none">
        <div class="flex items-center justify-between mb-4 relative z-10">
          <span class="text-[10px] text-gray-500 uppercase tracking-widest font-mono">Disp. Activos</span>
          <i class="ph ph-device-mobile text-lg text-purple-500"></i>
        </div>
        <p class="text-4xl font-mono text-white relative z-10 tracking-tight">{{ deviceCount }}</p>
        <div class="absolute bottom-0 left-0 h-1 bg-purple-500 w-0 group-hover:w-full transition-all duration-500"></div>
      </div>

      <!-- Avg Apdex -->
      <div class="bg-zaxis-dark border border-zaxis-border p-5 relative overflow-hidden group hover:border-zaxis-accent transition-colors rounded-none">
        <div class="flex items-center justify-between mb-4 relative z-10">
          <span class="text-[10px] text-gray-500 uppercase tracking-widest font-mono">Apdex Global</span>
          <i class="ph ph-globe text-lg text-zaxis-accent"></i>
        </div>
        <p class="text-4xl font-mono relative z-10 tracking-tight" [ngClass]="getApdexColorClass(globalAvgApdex)">{{ globalAvgApdex > 0 ? (globalAvgApdex | number:'1.2-2') : '--' }}</p>
        <div class="absolute bottom-0 left-0 h-1 bg-zaxis-accent w-0 group-hover:w-full transition-all duration-500"></div>
      </div>
    </div>
  `
})
export class DashboardKpiCardsComponent {
  @Input() sessionsCount: number = 0;
  @Input() crashCount: number = 0;
  @Input() crashRate: string = '0';
  @Input() globalAvgFps: number = 0;
  @Input() deviceCount: number = 0;
  @Input() globalAvgApdex: number = 0;

  getApdexColorClass(score: number): string {
    if (!score || score === 0) return 'text-white';
    if (score >= 0.85) return 'text-green-400';
    if (score >= 0.5) return 'text-yellow-400';
    return 'text-red-400';
  }
}
